import { IDropdownOption } from 'office-ui-fabric-react';

export const DayPickerStrings = {
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],

  shortMonths: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ],

  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ],

  shortDays: [
    'S',
    'M',
    'T',
    'W',
    'T',
    'F',
    'S'
  ],

  goToToday: 'Go to today',

  isRequiredErrorMessage: 'Start date is required.',

  invalidInputErrorMessage: 'Invalid date format.'
};

export const HOURS: IDropdownOption[] = [
    { text: '00', key: '00' },
    { text: '01', key: '01' },
    { text: '02', key: '02' },
    { text: '03', key: '03' },
    { text: '04', key: '04' },
    { text: '05', key: '05' },
    { text: '06', key: '06' },
    { text: '07', key: '07' },
    { text: '08', key: '08' },
    { text: '09', key: '09' },
    { text: '10', key: '10' },
    { text: '11', key: '11' },
    { text: '12', key: '12' },
    { text: '13', key: '13' },
    { text: '14', key: '14' },
    { text: '15', key: '15' },
    { text: '16', key: '16' },
    { text: '17', key: '17' },
    { text: '18', key: '18' },
    { text: '19', key: '19' },
    { text: '20', key: '20' },
    { text: '21', key: '21' },
    { text: '22', key: '22' },
    { text: '23', key: '23' }
];

export const MINUTES: IDropdownOption[] = [
    { text: '00', key: '00' },
    { text: '15', key: '15' }, 
    { text: '30', key: '30' },
    { text: '45', key: '45' }
];


// WEBPACK FOOTER //
// ./source/ts/constants/dateTime.ts